import SchoolSummaryPage from './SchoolSummaryPage';

export default SchoolSummaryPage;
